import { Box, CircularProgress } from '@mui/material';

const PageLoader = () => (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%" width="100%">
        <Box role="status" aria-live="polite" aria-label="Loading content">
            <CircularProgress />
        </Box>
    </Box>
);

export default PageLoader;
